import { animate, AnimationMetadata, style, transition } from '@angular/animations';

export const slideInAnimation: AnimationMetadata[] = [
  transition(':enter', [
    style({ transform: 'translateX(10%)' }),
    animate('500ms ease-in-out', style({ transform: 'translateX(0)' })),
  ]),
];
